import { faEllipsis, faScanner } from "@fortawesome/pro-regular-svg-icons";
import { faArrowDown } from "@fortawesome/pro-regular-svg-icons/faArrowDown";
import { faArrowProgress } from "@fortawesome/pro-regular-svg-icons/faArrowProgress";
import { faArrowUp } from "@fortawesome/pro-regular-svg-icons/faArrowUp";
import { faArrowUpArrowDown } from "@fortawesome/pro-regular-svg-icons/faArrowUpArrowDown";
import { faAsterisk } from "@fortawesome/pro-regular-svg-icons/faAsterisk";
import { faBarcodeScan } from "@fortawesome/pro-regular-svg-icons/faBarcodeScan";
import { faBell } from "@fortawesome/pro-regular-svg-icons/faBell";
import { faBoltLightning } from "@fortawesome/pro-regular-svg-icons/faBoltLightning";
import { faBook } from "@fortawesome/pro-regular-svg-icons/faBook";
import { faBookSection } from "@fortawesome/pro-regular-svg-icons/faBookSection";
import { faBroom } from "@fortawesome/pro-regular-svg-icons/faBroom";
import { faBrowser } from "@fortawesome/pro-regular-svg-icons/faBrowser";
import { faBuilding } from "@fortawesome/pro-regular-svg-icons/faBuilding";
import { faBuildings } from "@fortawesome/pro-regular-svg-icons/faBuildings";
import { faCamera } from "@fortawesome/pro-regular-svg-icons/faCamera";
import { faCameraViewfinder } from "@fortawesome/pro-regular-svg-icons/faCameraViewfinder";
import { faCancel } from "@fortawesome/pro-regular-svg-icons/faCancel";
import { faCaretSquareDown } from "@fortawesome/pro-regular-svg-icons/faCaretSquareDown";
import { faCaretSquareUp } from "@fortawesome/pro-regular-svg-icons/faCaretSquareUp";
import { faChartPie } from "@fortawesome/pro-regular-svg-icons/faChartPie";
import { faChartUser } from "@fortawesome/pro-regular-svg-icons/faChartUser";
import { faCheckSquare } from "@fortawesome/pro-regular-svg-icons/faCheckSquare";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { faClipboardCheck } from "@fortawesome/pro-regular-svg-icons/faClipboardCheck";
import { faClipboardList } from "@fortawesome/pro-regular-svg-icons/faClipboardList";
import { faClock } from "@fortawesome/pro-regular-svg-icons/faClock";
import { faClose } from "@fortawesome/pro-regular-svg-icons/faClose";
import { faCodeBranch } from "@fortawesome/pro-regular-svg-icons/faCodeBranch";
import { faCog } from "@fortawesome/pro-regular-svg-icons/faCog";
import { faCopy } from "@fortawesome/pro-regular-svg-icons/faCopy";
import { faCopyright } from "@fortawesome/pro-regular-svg-icons/faCopyright";
import { faDatabase } from "@fortawesome/pro-regular-svg-icons/faDatabase";
import { faDebug } from "@fortawesome/pro-regular-svg-icons/faDebug";
import { faDoorClosed } from "@fortawesome/pro-regular-svg-icons/faDoorClosed";
import { faDoorOpen } from "@fortawesome/pro-regular-svg-icons/faDoorOpen";
import { faDownload } from "@fortawesome/pro-regular-svg-icons/faDownload";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";
import { faExclamationSquare } from "@fortawesome/pro-regular-svg-icons/faExclamationSquare";
import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeDropper } from "@fortawesome/pro-regular-svg-icons/faEyeDropper";
import { faFileArrowDown } from "@fortawesome/pro-regular-svg-icons/faFileArrowDown";
import { faFileChartPie } from "@fortawesome/pro-regular-svg-icons/faFileChartPie";
import { faFileExport } from "@fortawesome/pro-regular-svg-icons/faFileExport";
import { faFileImport } from "@fortawesome/pro-regular-svg-icons/faFileImport";
import { faFilePdf } from "@fortawesome/pro-regular-svg-icons/faFilePdf";
import { faFileZip } from "@fortawesome/pro-regular-svg-icons/faFileZip";
import { faFlag } from "@fortawesome/pro-regular-svg-icons/faFlag";
import { faFolderArrowDown } from "@fortawesome/pro-regular-svg-icons/faFolderArrowDown";
import { faGlobe } from "@fortawesome/pro-regular-svg-icons/faGlobe";
import { faHeartBroken } from "@fortawesome/pro-regular-svg-icons/faHeartBroken";
import { faKeySkeleton } from "@fortawesome/pro-regular-svg-icons/faKeySkeleton";
import { faLandMineOn } from "@fortawesome/pro-regular-svg-icons/faLandMineOn";
import { faLanguage } from "@fortawesome/pro-regular-svg-icons/faLanguage";
import { faLayerGroup } from "@fortawesome/pro-regular-svg-icons/faLayerGroup";
import { faLock } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faMagnifyingGlassMinus } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlassMinus";
import { faMicroscope } from "@fortawesome/pro-regular-svg-icons/faMicroscope";
import { faNotdef } from "@fortawesome/pro-regular-svg-icons/faNotdef";
import { faPalette } from "@fortawesome/pro-regular-svg-icons/faPalette";
import { faPanelEws } from "@fortawesome/pro-regular-svg-icons/faPanelEws";
import { faPaperPlane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane";
import { faPencil } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { faPencilRuler } from "@fortawesome/pro-regular-svg-icons/faPencilRuler";
import { faPlayCircle } from "@fortawesome/pro-regular-svg-icons/faPlayCircle";
import { faPlug } from "@fortawesome/pro-regular-svg-icons/faPlug";
import { faPlusSquare } from "@fortawesome/pro-regular-svg-icons/faPlusSquare";
import { faPrint } from "@fortawesome/pro-regular-svg-icons/faPrint";
import { faQrcode } from "@fortawesome/pro-regular-svg-icons/faQrcode";
import { faQuestion } from "@fortawesome/pro-regular-svg-icons/faQuestion";
import { faRadar } from "@fortawesome/pro-regular-svg-icons/faRadar";
import { faRectangleHistory } from "@fortawesome/pro-regular-svg-icons/faRectangleHistory";
import { faRedoAlt } from "@fortawesome/pro-regular-svg-icons/faRedoAlt";
import { faRefresh } from "@fortawesome/pro-regular-svg-icons/faRefresh";
import { faRotateBack } from "@fortawesome/pro-regular-svg-icons/faRotateBack";
import { faSave } from "@fortawesome/pro-regular-svg-icons/faSave";
import { faSearch } from "@fortawesome/pro-regular-svg-icons/faSearch";
import { faSignInAlt } from "@fortawesome/pro-regular-svg-icons/faSignInAlt";
import { faSignOutAlt } from "@fortawesome/pro-regular-svg-icons/faSignOutAlt";
import { faSlidersH } from "@fortawesome/pro-regular-svg-icons/faSlidersH";
import { faSquare } from "@fortawesome/pro-regular-svg-icons/faSquare";
import { faSquareO } from "@fortawesome/pro-regular-svg-icons/faSquareO";
import { faSquareQuestion } from "@fortawesome/pro-regular-svg-icons/faSquareQuestion";
import { faSquareXmark } from "@fortawesome/pro-regular-svg-icons/faSquareXmark";
import { faSwatchbook } from "@fortawesome/pro-regular-svg-icons/faSwatchbook";
import { faSync } from "@fortawesome/pro-regular-svg-icons/faSync";
import { faTable } from "@fortawesome/pro-regular-svg-icons/faTable";
import { faTachometerAlt } from "@fortawesome/pro-regular-svg-icons/faTachometerAlt";
import { faTag } from "@fortawesome/pro-regular-svg-icons/faTag";
import { faTimesSquare } from "@fortawesome/pro-regular-svg-icons/faTimesSquare";
import { faTools } from "@fortawesome/pro-regular-svg-icons/faTools";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faTrashCanUndo } from "@fortawesome/pro-regular-svg-icons/faTrashCanUndo";
import { faUpload } from "@fortawesome/pro-regular-svg-icons/faUpload";
import { faUser } from "@fortawesome/pro-regular-svg-icons/faUser";
import { faUsers } from "@fortawesome/pro-regular-svg-icons/faUsers";
import { faWrench } from "@fortawesome/pro-regular-svg-icons/faWrench";
// General icons.
export const SCAN_ICON = { icon: faScanner };
export const CLOCK_ICON = { icon: faClock };
export const EMAIL_ICON = { icon: faEnvelope };
export const SORT_ASCENDING_ICON = { icon: faCaretSquareUp };
export const SORT_DESCENDING_ICON = { icon: faCaretSquareDown };
export const NO_RESULTS_ICON = { icon: faMagnifyingGlassMinus };
export const DEPLOYMENT_ICON = { icon: faCodeBranch };
export const PTP_ICON = { icon: faBook };
export const EXPORT_ICON = { icon: faFileExport };
export const IMPORT_ICON = { icon: faFileImport };
export const UP_ICON = { icon: faArrowUp };
export const DOWN_ICON = { icon: faArrowDown };
export const GENERATE_PASSWORD_ICON = { icon: faKeySkeleton };
export const STATISTICS_ICON = { icon: faChartPie };
export const CONFIRM_ICON = { icon: faCheckSquare };
export const DEBUG_ICON = { icon: faDebug };
export const LOADING_ICON = { icon: faCog, spin: true };
export const RELOADING_ICON = { icon: faEllipsis, fade: true };
export const ERROR_ICON = { icon: faExclamationSquare };
export const LIBRARY_ICON = { icon: faRectangleHistory };
export const SEARCH_ICON = { icon: faSearch };
export const OFFLINE_ICON = { icon: faHeartBroken };
export const SUCCESS_ICON = { icon: faCheckSquare };
export const WARNING_ICON = { icon: faExclamationSquare };
export const VIEW_ICON = { icon: faEye };
export const DOWNLOAD_ICON = { icon: faDownload };
export const DOWNLOAD_SINGLE_ICON = { icon: faFileArrowDown };
export const DOWNLOAD_MULTIPLE_ICON = { icon: faFolderArrowDown };
export const REPORT_ICON = { icon: faFileChartPie };
export const ADD_ICON = { icon: faPlusSquare };
export const CREATE_ICON = { icon: faPlusSquare };
export const INJECT_ICON = { icon: faDownload };
export const FRESH_ICON = { icon: faPlusSquare };
export const PENDING_ICON = { icon: faClock };
export const TIP_ICON = { icon: faSquareQuestion };
export const COLOR_ICON = { icon: faSwatchbook };
export const FIX_ICON = { icon: faWrench };
export const NOT_AVAILABLE_ICON = { icon: faNotdef };
export const UPLOAD_ICON = { icon: faUpload };
export const CAMERA_ICON = { icon: faCamera };
export const OCR_ICON = { icon: faCameraViewfinder };
export const DELETE_ICON = { icon: faTrash };
export const RESTORE_ICON = { icon: faTrashCanUndo };
export const OPEN_ICON = { icon: faDoorOpen };
export const ENERGIZED_ICON = { icon: faBoltLightning };
export const PDF_ICON = { icon: faFilePdf };
export const ZIP_ICON = { icon: faFileZip };
export const SYNCING_ICON = { icon: faSync, spin: true };
export const SQL_ICON = { icon: faDatabase };
export const LOGO_ICON = { icon: faLock };
export const SAVE_ICON = { icon: faSave };
export const CANCEL_ICON = { icon: faCancel };
export const LOGIN_ICON = { icon: faSignInAlt };
export const SYNC_ICON = { icon: faArrowUpArrowDown };
export const LOGOUT_ICON = { icon: faSignOutAlt };
export const CAMERA_TAKE_ICON = { icon: faSquareO };
export const CAMERA_CLOSE_ICON = { icon: faSquareXmark };
export const CLONE_ICON = { icon: faCopy };
export const EDIT_ICON = { icon: faPencil };
export const APPROVE_ICON = { icon: faCheckSquare };
export const BULK_EDIT_ICON = { icon: faTable };
export const USER_ICON = { icon: faUser };
export const RETRY_ICON = { icon: faRedoAlt };
export const BACK_ICON = { icon: faRotateBack };
export const PRINT_ICON = { icon: faPrint };
export const PRINTING_ICON = LOADING_ICON;
export const RELOAD_ICON = { icon: faDatabase };
export const REFRESH_ICON = { icon: faRefresh };
export const ALERT_ICON = { icon: faBell };
export const QR_CODE_ICON = { icon: faQrcode };
export const COPY_ICON = { icon: faCopy };
export const RESET_ICON = { icon: faBroom };
export const DASHBOARD_ICON = { icon: faTachometerAlt };
export const USERS_ICON = { icon: faUsers };
export const COMPANY_ICON = { icon: faCopyright };
export const PUBLIC_ICON = { icon: faGlobe };
export const ENTER_ICON = { icon: faDoorOpen };
export const EXIT_ICON = { icon: faDoorClosed };
export const NEXT_ICON = { icon: faChevronRight };
export const PREVIOUS_ICON = { icon: faChevronLeft };
export const HELP_ICON = { icon: faQuestion };
export const HTML_ICON = { icon: faBrowser };
export const CSS_ICON = { icon: faPalette };
export const SAMPLE_DATA_ICON = { icon: faDatabase };
export const CLOSE_ICON = { icon: faClose };
export const EXECUTE_ICON = { icon: faPlayCircle };
export const LOCATION_ICON = { icon: faBuilding };
export const SETTINGS_ICON = { icon: faSlidersH };
export const TOOLS_ICON = { icon: faTools };
export const EMPTY_ICON = { icon: faSquare };
export const STATUS_ICON = { icon: faTag };
export const BROWSE_ICON = { icon: faTable };
export const DATA_CHECK_ICON = { icon: faClipboardCheck };
export const DELIVERY_ICON = { icon: faBarcodeScan };
export const ADMIN_ICON = { icon: faCog };
export const ICON_PASSED = { icon: faCheckSquare };
export const ICON_FAILED = { icon: faTimesSquare };
export const REVIEW_ICON = { icon: faClipboardList };
export const USAGE_ICON = { icon: faChartUser };
export const SITES_ICON = { icon: faBuildings };
export const PUBLISH_ICON = { icon: faPaperPlane };
// Icons for entities.
export const MONITORING_ICON = { icon: faRadar };
export const ASSET_ICON = { icon: faPanelEws };
export const PROCEDURE_ICON = { icon: faArrowProgress };
export const INSPECTION_ICON = { icon: faMicroscope };
export const CONTROL_POINT_ICON = { icon: faPlug };
export const SEVERITY_ICON = { icon: faLandMineOn };
export const TRANSLATION_ICON = { icon: faLanguage };
export const ASSET_TYPE_ICON = { icon: faLayerGroup };
export const CUSTOM_FIELD_ICON = { icon: faAsterisk };
export const ENERGY_MEASURE_ICON = { icon: faTachometerAlt };
export const ENERGY_SOURCE_ICON = { icon: faBoltLightning };
export const HAZARD_ICON = { icon: faLandMineOn };
export const INSPECTION_REASON_ICON = { icon: faBookSection };
export const ISOLATION_DEVICE_ICON = { icon: faPlug };
export const TEMPLATE_ICON = { icon: faPencilRuler };
export const AUDIT_ICON = { icon: faClipboardCheck };
export const PROCEDURE_TYPE_ICON = { icon: faLayerGroup };
export const PROCEDURE_TEMPLATE_ICON = { icon: faEyeDropper };
export const LANGUAGE_ICON = { icon: faFlag };
